import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "حاسبة العوامل - احسب العوامل الأولية";
const DESCRIPTION =
  "اكتشف جميع عوامل العدد الصحيح الموجب بسهولة وسرعة باستخدام آلة حاسبة العوامل. احصل على قائمة كاملة بالعوامل، بما في ذلك العوامل الأولية، لمساعدتك في فهم بنية الأعداد. أداة تعليمية قيمة للطلاب والمعلمين، كما أنها مفيدة لحل المسائل الرياضية التي تتطلب تحليل الأعداد إلى عواملها الأولية.";
const KEYWORDS =
  "عوامل، عوامل أولية، حاسبة، عوامل العدد، آلة حاسبة عوامل، عدد صحيح موجب، رياضيات، تعليمية، عوامل أولية، تحليل الأعداد.";
const OG_URL = "https://do-calculate.com/calculator/ar/factors-calculator";
const FactorsCalculator = () => {
  const [number, setNumber] = useState("");
  const [factors, setFactors] = useState([]);
  const [factorPairs, setFactorPairs] = useState([]);
  const [primeFactors, setPrimeFactors] = useState([]);
  const [primeFactorSteps, setPrimeFactorSteps] = useState([]);
  const [error, setError] = useState("");
  const calculateFactors = (num) => {
    const factorsList = [];
    for (let i = 1; i <= Math.sqrt(num); i++) {
      if (num % i === 0) {
        factorsList.push(i);
        if (i !== num / i) {
          factorsList.push(num / i);
        }
      }
    }
    return factorsList.sort((a, b) => a - b);
  };
  const calculateFactorPairs = (num) => {
    const pairs = [];
    for (let i = 1; i <= Math.sqrt(num); i++) {
      if (num % i === 0) {
        pairs.push([i, num / i]);
      }
    }
    return pairs;
  };
  const primeFactorsSteps = (num) => {
    const steps = [];
    const factors = [];
    for (let i = 2; i <= num; i++) {
      while (num % i === 0) {
        factors.push(i);
        steps.push(`${num} | ${i}`);
        num = num / i;
      }
    }
    return { factors, steps };
  };
  const handleCalculate = () => {
    try {
      const num = parseInt(number, 10);
      if (isNaN(num) || num <= 0) {
        throw new Error("الرجاء إدخال عدد صحيح موجب.");
      }
      const factorsList = calculateFactors(num);
      const factorPairsList = calculateFactorPairs(num);
      const { factors, steps } = primeFactorsSteps(num);
      setFactors(factorsList);
      setFactorPairs(factorPairsList);
      setPrimeFactors(factors);
      setPrimeFactorSteps(steps);
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  مرحبًا بكم في <strong>حاسبة العوامل الأولية</strong>! تتيح لك
                  هذه الأداة المتقدمة اكتشاف جميع عوامل العدد الصحيح الموجب
                  بسرعة وسهولة. باستخدام هذه الحاسبة، يمكنك الحصول على قائمة
                  شاملة بالعوامل، بما في ذلك العوامل الأولية، مما يعزز فهمك
                  لبنية الأعداد وكيفية تحليلها إلى مكوناتها الأساسية.
                </p>
                <p>
                  <strong>ما هي العوامل الأولية؟</strong> العوامل الأولية هي
                  الأعداد الأولية التي تقسم عددًا معينًا بدون باقي. تحليل
                  الأعداد إلى عواملها الأولية هو خطوة أساسية في العديد من
                  المسائل الرياضية، من الجبر إلى نظرية الأعداد. باستخدام
                  حاسبتنا، يمكنك إجراء هذه التحليلات بسهولة وسرعة، مما يوفر لك
                  الوقت ويساعدك في تحقيق نتائج دقيقة.
                </p>
                <p>
                  <strong>كيفية استخدام الحاسبة:</strong> ما عليك سوى إدخال
                  العدد الصحيح الموجب في الحقل المخصص، واضغط على زر الحساب.
                  ستعرض لك الأداة جميع العوامل، بما في ذلك العوامل الأولية،
                  بطريقة واضحة وسهلة القراءة. هذه الحاسبة مثالية للطلاب الذين
                  يدرسون الرياضيات، والمعلمين الذين يحتاجون إلى أداة تعليمية،
                  وأي شخص يحتاج إلى تحليل الأعداد في عمله اليومي.
                </p>
                <p>
                  <strong>مميزات حاسبة العوامل:</strong>
                  <ul>
                    <li>تحليل دقيق وسريع لجميع عوامل العدد الصحيح الموجب.</li>
                    <li>
                      توفير قائمة كاملة بالعوامل الأولية للعناصر الرياضية
                      الأساسية.
                    </li>
                    <li>واجهة مستخدم بسيطة وسهلة الاستخدام.</li>
                    <li>
                      أداة تعليمية مثالية للطلاب والمعلمين في الدروس الرياضية.
                    </li>
                    <li>
                      مساعدة في حل المسائل الرياضية المعقدة التي تتطلب تحليل
                      الأعداد.
                    </li>
                  </ul>
                </p>
                <p>
                  استفد من هذه الأداة المجانية عبر الإنترنت لتعزيز فهمك
                  للرياضيات وتسهيل تحليلك للأعداد. استخدم{" "}
                  <strong>حاسبة العوامل الأولية</strong> الآن للحصول على نتائج
                  دقيقة وفعالة!
                </p>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          أدخل عدد صحيح موجب
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="مثال: 120"
                        value={number}
                        onChange={(e) => setNumber(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  <div>
                    { error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      factors.length > 0 && (
                        <div className="p-3 mb-2 bg-success text-white">
                          <p className="text-white">
                            العوامل: {factors.join(", ")}
                          </p>
                          <p className="text-white">
                            أزواج العوامل:{" "}
                            {factorPairs
                              .map((pair) => `(${pair.join(", ")})`)
                              .join(" ")}
                          </p>
                          <p className="text-white">
                            العوامل الأولية: {number} ={" "}
                            {primeFactors.join(" × ")}
                          </p>
                          <h4 className="text-white">الخطوات:</h4>
                          {primeFactorSteps.map((step, index) => (
                            <p key={index} className="text-white">
                              {step}
                            </p>
                          ))}
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="col-12 col-md-8">
        <div className="info-sections-container">
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>ما هي العوامل؟</h3>
            </div>
            <div className="info-section-body">
              <p>
                العوامل هي الأعداد التي يمكن ضربها معًا للحصول على عدد معين. على
                سبيل المثال، إذا أخذنا العدد 12، فإن العوامل التي يمكن ضربها
                معًا لتكوين العدد 12 هي 1، 2، 3، 4، 6، و12. هذه الأعداد تعرف
                بالعوامل لأنها "تُعْتَبَرُ" ضمن عملية الضرب لتكوين العدد
                المطلوب.
              </p>
              <p>
                على سبيل المثال، يمكن كتابة 12 كـ 1 × 12، 2 × 6، أو 3 × 4. لفهم
                العوامل بشكل أفضل، يمكن تصورها كأجزاء صغيرة تشكل العدد الأكبر
                عند ضربها معًا.
              </p>
              <p>
                يمكن استخدام فهم العوامل في العديد من التطبيقات الرياضية، مثل
                تبسيط الكسور وتحليل الأعداد إلى عواملها الأساسية.
              </p>
            </div>
          </div>
          <div className="info-section">
            <div className="info-section-header">
              <h3 style={{ fontSize: "16px" }}>ما هي العوامل الأولية؟</h3>
            </div>
            <div className="info-section-body">
              <p>
                العوامل الأولية هي الأعداد التي لا تقبل القسمة إلا على نفسها
                وعلى 1. هذه الأعداد هي اللبنات الأساسية للأعداد الأخرى، حيث يمكن
                تحليل أي عدد إلى مجموعة من العوامل الأولية.
              </p>
              <p>
                على سبيل المثال، العوامل الأولية للعدد 12 هي 2 × 2 × 3. هذا يعني
                أن 12 يمكن كتابته كمنتج من العوامل الأولية 2 و3، حيث يتم تكرار
                العدد 2 مرتين.
              </p>
              <p>
                فهم العوامل الأولية يساعد في تحليل الأعداد إلى مكوناتها
                الأساسية، وهو أمر مفيد في الرياضيات لتبسيط الكسور وحل المسائل
                الرياضية المعقدة. يُعتبر تحليل الأعداد إلى عواملها الأولية جزءاً
                أساسياً من نظرية الأعداد.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FactorsCalculator;
